import "./InviteMembersModal.scss";

import { useCallback, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

import { CustomModal } from "../../../../../components/CustomModal";
import { useOrganizationContext } from "../../../../../contexts/organizations/organizationsContext";
import { useUser } from "../../../../../contexts/userContext";
import { useInviteUser } from "../../../../../hooks/reactQueryHooks/useOrganization";
import { InviteMembersFooter } from "./InviteMembersFooter";
// import { InviteMultipleMembers } from "./InviteMultipleMembers";
import { InviteSingleMember } from "./InviteSingleMember";

// const invitationVariants = [
//   {
//     label: 'Invite a single member',
//     value: 'single',
//   },
//   {
//     label: 'Invite multiple members at once',
//     value: 'multiple',
//   },
// ];

const InviteMembersModal = () => {
  const [currentVariant] = useState<string>("single");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [disabledSubmit, setDisabledSubmit] = useState<boolean>(true);
  const [invitationData, setInvitationData] = useState<any>({});
  // const [multipleMembers, setMultipleMembers] = useState<string>("");
  // const [multipleMembersError, setMultipleMembersError] = useState<any>(null);
  const [showError, setShowError] = useState<string>("");
  const [validationErrors, setValidationErrors] = useState<{
    [key: string]: string;
  } | null>(null);

  const { user } = useUser();
  const { currentOrganization } = useOrganizationContext();
  const inviteUserMutation = useInviteUser();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleClick = () => {
    setShowModal(true);
  };

  const handleClose = useCallback(() => {
    setShowModal(false);
    setShowError("");
    setValidationErrors(null);
  }, [setShowModal]);

  useEffect(() => {
    if (inviteUserMutation.isLoading) {
      setDisabledSubmit(true);
      return;
    }
    setDisabledSubmit(false);
  }, [currentVariant, validationErrors, inviteUserMutation.isLoading]);

  useEffect(() => {
    if (inviteUserMutation.isSuccess) {
      handleClose();
      const invitationsPath = "/organization/members/invitations";
      if (pathname !== invitationsPath) {
        navigate(invitationsPath);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inviteUserMutation.isSuccess, handleClose]);

  useEffect(() => {
    if (
      inviteUserMutation.isError &&
      inviteUserMutation?.error?.response?.data?.length
    ) {
      const validationErrors: {
        [key: string]: string;
      } = {};
      inviteUserMutation.error.response?.data.forEach((error: any) => {
        if (error.type === "Validation") {
          validationErrors[error.code] = error.description;
          return;
        }
        setShowError(error.code);
      });
      setValidationErrors(validationErrors);
      return;
    } else {
      setShowError(inviteUserMutation?.error?.response?.data?.code || "");
    }
    setValidationErrors(null);
  }, [inviteUserMutation.isError, inviteUserMutation?.error?.response?.data]);

  // const [checkEmailResult, setCheckEmailResult] = useState<{
  //   emails: string[];
  //   notEmails: string[];
  // }>({
  //   emails: [],
  //   notEmails: [],
  // });

  // const extractEmails = (inputText: string) => {
  //   const emails: string[] = [];
  //   const notEmails: string[] = [];
  //   const emailPattern =
  //     /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
  //   inputText
  //     .split(/,|\,\s*|\s+/)
  //     .filter(Boolean)
  //     .forEach(string => {
  //       if (emailPattern.test(string)) {
  //         emails.push(string);
  //         return;
  //       }
  //       notEmails.push(string);
  //     });
  //   setCheckEmailResult({ emails, notEmails });
  // };
  // useEffect(() => {
  //   setMultipleMembersError(null);
  //   if (!multipleMembers) {
  //     setDisabledSubmit(true);
  //     return;
  //   }
  //   setDisabledSubmit(false);
  //   extractEmails(multipleMembers);
  // }, [multipleMembers]);

  const inviteMembers = () => {
    // if (currentVariant === "multiple") {
    //   if (
    //     !checkEmailResult.notEmails.length &&
    //     checkEmailResult.emails.length
    //   ) {
    //     console.log("send request");
    //   } else {
    //     console.log("show error");
    //     setMultipleMembersError(checkEmailResult);
    //     setDisabledSubmit(true);
    //   }
    //   return;
    // }
    inviteUserMutation.mutate({
      invitee: {
        ...invitationData,
      },
      inviter: {
        id: user?.sub || "",
      },
      organizationId: currentOrganization?.id || "",
      roles: ["admin"],
    });
  };

  const errors: Record<string, string> = {
    "General.Conflict": "Invitation already exists",
    UserAlreadyMember: "User is already a member of the organization",
    default: `Adding members is disabled while there is no active subscription for the ${currentOrganization?.name} organization.`,
  };

  return (
    <>
      {showModal && (
        <CustomModal
          show={true}
          handleClose={handleClose}
          title="Invite member"
          errorMessage={showError ? errors[showError] || errors.default : ""}
          footer={
            <InviteMembersFooter
              disabledSubmit={disabledSubmit}
              cancelInvite={handleClose}
              inviteMembers={inviteMembers}
              isProcessing={inviteUserMutation.isLoading}
            />
          }
        >
          <div className="">
            {currentVariant === "single" && (
              <InviteSingleMember
                setErrorState={setDisabledSubmit}
                setInvitationData={setInvitationData}
                validationErrors={validationErrors}
              />
            )}
            {/* {currentVariant === "multiple" && (
              <InviteMultipleMembers
                setInvitationData={setInvitationData}
                setMultipleMembers={setMultipleMembers}
                error={multipleMembersError}
              />
            )} */}
          </div>
        </CustomModal>
      )}

      <div className="d-flex">
        <Button onClick={handleClick} className="flex-shrink-0 ms-md-auto">
          + Invite member
        </Button>
      </div>
    </>
  );
};

export { InviteMembersModal };
